import { useEffect, FC } from 'react';
import { useLocation } from 'react-router-dom';
import { resetToDefaultFavicon } from '../utils/faviconUtils';

const FaviconManager: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only reset favicon if we're NOT on a portfolio page
    if (!pathname.startsWith('/portfolio/')) {
      resetToDefaultFavicon();
    }
  }, [pathname]);

  return null;
};

export default FaviconManager; 